import { combineReducers, createStore } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  sidebarReducer,
  themeReducer,
  customizerReducer,
  rtlReducer,
  authReducer, commonReducer
} from '../../redux/reducers/index';

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  rtl: rtlReducer,
  sidebar: sidebarReducer,
  customizer: customizerReducer,
  loginUser: authReducer,
  commonData: commonReducer
});
const store = createStore(reducer);

export default store;
